// ** Core JWT Import
import UseJwt from '@src/@core/auth/jwt/useJwt'

const { jwt } = UseJwt({})

export default jwt
